import { render, staticRenderFns } from "./AppsFeatures.vue?vue&type=template&id=4e4c1566&scoped=true&"
import script from "./AppsFeatures.vue?vue&type=script&lang=js&"
export * from "./AppsFeatures.vue?vue&type=script&lang=js&"
import style0 from "./AppsFeatures.vue?vue&type=style&index=0&id=4e4c1566&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4c1566",
  null
  
)

export default component.exports